import React from "react";
import { Link } from "react-router-dom";

const WhyChooseUsItem = (props) => {
  return (
    <div 
      className="choose-item p-3 text-center shadow"
      style={{
        backgroundColor: "rgba(33, 37, 41, 0.4)",
        borderRadius: "25px",
        border: "1px solid rgba(255, 255, 255, 0.1)",
        minHeight: "220px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <div className="choose-icon mb-3" style={{ 
        fontSize: "1.5rem", 
        color: "#17a2b8",
        width: "auto",
        height: "auto",
        background: "none",
        border: "none",
        borderRadius: "0"
      }}>
        {props.item.icon}
      </div>
      <div className="choose-content">
        <h3 className="title text-white mb-3" style={{ fontSize: "1.2rem", fontWeight: "bold" }}>
          {props.item.title}
        </h3>
        <p className="text-light" style={{ fontSize: "0.9rem", lineHeight: "1.5" }}>
          {props.item.description}
        </p>
      </div>
    </div>
  );
};

export default WhyChooseUsItem;
